import axios from 'axios'
import { environment } from '@/data/environment'
import { encryptPassword } from '@/auth/encryptPassword'

export default {
  state: {
    loggedInUser:
      localStorage.getItem('uid') != null
        ? JSON.parse(atob(localStorage.getItem('uid')))
        : null,
    loading: false,
    error: null,
    user: null,
    nameUser: null,
  },
  getters: {
    loggedInUser: state => state.loggedInUser,
    loading: state => state.loading,
    error: state => state.error,
  },
  mutations: {
    setUser (state, data) {
      state.loggedInUser = data
      state.loading = false
      state.error = null
      state.user = data.user
      state.nameUser = data.name
    },
    setLoading (state, data) {
      state.loading = data
      state.error = null
    },
    setError (state, data) {
      state.error = data
      state.loggedInUser = null
      state.loading = false
    },
    clearError (state) {
      state.error = null
    },
  },
  actions: {
    login ({ commit }, data) {
      const email = data.email
      const pass = data.password
      const endpoint = '/loginUi'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .post(url, data)
        .then(response => {
        const dataResponse = response.data
          if (dataResponse.Error) {
            commit('setError', dataResponse.Mensaje)
          } else {
            const span = encryptPassword(pass)
            const dataUser = { user: email, span: span, userId: dataResponse.data.id, nameUser: dataResponse.data.name, idcompania: dataResponse.data.compania, rol: dataResponse.data.rol, apps: dataResponse.data.apps, jwt: dataResponse.data.token }
            localStorage.setItem('uid', btoa(JSON.stringify(dataUser)))
            localStorage.setItem('permissions', JSON.stringify(dataResponse.data.permissions))
            localStorage.setItem('role', JSON.stringify(dataResponse.data.role))
            commit('setUser', dataUser)
          }
        })
        .catch(function (error) {
          console.log(error.message)
          localStorage.removeItem('uid')
          localStorage.removeItem('permissions')
          localStorage.removeItem('role')
        })
    },
    clearerror ({ commit }) {
      commit('clearError')
    },
    logout ({ commit }) {
      localStorage.removeItem('uid')
      localStorage.removeItem('permissions')
      localStorage.removeItem('role')
    },
    async generateTokenEmail ({ commit }, { email, url }) {
      const endpoint = '/generatePasswordToken'
      const apiUrl = environment.HIOPOSWEBSERVICES + endpoint
      try {
        const response = await axios.post(apiUrl, { email, url })
        return response.data
      } catch (error) {
        const mensaje = error.response?.data?.Mensaje || 'Hubo un problema al generar el token. Intente nuevamente.'
        return { error: true, Mensaje: mensaje }
      }
    },
  },
}
